import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/Card';
import Badge from '@/components/ui/Badge';
import { getPlanGenerationCheck } from '@/api/plansService';
import { issueMessage } from './issueMessages';
import { queryKeys } from '@/lib/queryKeys';

const GenerationCheckPanel = ({ planId, dirty }: { planId: string | undefined; dirty: boolean }) => {
  const { data, isLoading } = useQuery({
    queryKey: queryKeys.pv2PlanGenerationCheck(planId ?? ''),
    queryFn: () => getPlanGenerationCheck(planId!),
    enabled: Boolean(planId),
  });

  return (
    <Card className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">Génération</p>
        {!planId || dirty ? (
          <Badge color="gray">Enregistrez pour vérifier</Badge>
        ) : isLoading || !data ? (
          <Badge color="gray">Vérification…</Badge>
        ) : data.generable ? (
          <Badge color="green">Plan générable</Badge>
        ) : (
          <Badge color="red">
            {data.issueCount} problème{data.issueCount > 1 ? 's' : ''}
          </Badge>
        )}
      </div>
      {planId && !dirty && data && !data.generable && (
        <ul className="space-y-1 text-xs text-gray-600 dark:text-gray-300">
          {data.issues.map((issue, i) => (
            <li key={i} className="flex items-start gap-2">
              <span className="text-error-500">•</span>
              {issue.cycleId ? (
                <Link to={`/cycles/${issue.cycleId}`} className="hover:underline">
                  {issueMessage(issue, data.cycleNames[issue.cycleId])}
                </Link>
              ) : (
                <span>{issueMessage(issue, undefined)}</span>
              )}
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
};

export default GenerationCheckPanel;
